export enum StyleClass {
  Checkmark = "checkmark",
  Warning = "warning",
  Required = "required",
  Question = "question",
  None = "none"
}
